import { memo } from "react";

import { Accordion } from "@narmi/design_system";

import MenuItemHeader from "./MenuItemHeader";
import styles from "./MenuItem.module.scss";
import SidebarTopLevelNAFItem from "./SidebarTopLevelNAFItem";
import useMenuItemOptions from "./useMenuItemOptions";

import type { SidebarRootItem } from "../sidebar.types";

interface MenuItemProps extends Omit<SidebarRootItem, "key"> {
  /**
   * Allows external control of Accordion state
   */
  isOpen?: boolean;
  itemKey: string;
  isActive?: boolean;
  onUserToggle?: (isOpen: boolean) => void;
}

const MenuItem = ({
  itemKey,
  route,
  isOpen,
  menuOptions = [],
  customMenuOptions,
  nafApp,
  ...props
}: MenuItemProps) => {
  const renderedMenuOptions = useMenuItemOptions({
    menuOptions,
    customMenuOptions,
    isOpen,
    itemKey,
  });

  // Top-level NAF app — clicking triggers AppAuthorize
  if (nafApp) {
    return (
      <SidebarTopLevelNAFItem
        nafApp={nafApp}
        title={props.title}
        icon={props.icon}
        isActive={props.isActive}
      />
    );
  }

  // Header-only item (no sub-items)
  if (!customMenuOptions && menuOptions.length === 0) {
    return <MenuItemHeader route={route} {...props} />;
  }

  // Expandable item with sub-items
  return (
    <Accordion
      isOpen={isOpen}
      renderSummary={() => (
        <MenuItemHeader isOpen={isOpen} route={route} {...props} />
      )}
    >
      <div className={styles["menu-item-section-expanded"]}>
        {renderedMenuOptions}
      </div>
    </Accordion>
  );
};

export default memo(MenuItem);
